import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhoWeAre from "./components/WhoWeAre";
import WhyWeAreBest from "./components/WhyWeAreBest";
import OurBrands from "./components/OurBrands";
import Items from "./components/Items";
import SuccessNumbers from "./components/SuccessNumbers";
import Footer from "./components/Footer";
import About from "./components/About.js";
import Contact from "./components/Contact.js";
import Brands from "./components/Brands.js";
import ScrollToTop from "./components/ScrollToTop";
import Z1 from "./components/Z1.js";
import Z2 from "./components/Z2.js";
import Z3 from "./components/Z3.js";
import Z4 from "./components/Z4.js";
import Z5 from "./components/Z5.js";
import Z6 from "./components/Z6.js";
import Z7 from "./components/Z7.js";
import Z8 from "./components/Z8.js";
import Z9 from "./components/Z9.js";
import Z10 from "./components/Z10.js";
import Z11 from "./components/Z11.js";
import Z12 from "./components/Z12.js";
import Products from "./components/Products.js";
import Partners from "./components/Partners.js";

   // ✅ नया About page

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <WhoWeAre />
      <WhyWeAreBest />
      <Items />
      <Partners />
      <OurBrands />
      <SuccessNumbers />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />      {/* Home page */}
        <Route path="/about" element={<About />} />{/* About page */}
        <Route path="/brands" element={<Brands />} />{/* Brands page */}
        <Route path="/products" element={<Products />} />{/* Navitm page */}
        <Route path="/contact" element={<Contact />} />{/* Contact page */}
        <Route path="/z1" element={<Z1 />} />{/* Z1 page */}
        <Route path="/z2" element={<Z2 />} />{/* Z2 page */}
        <Route path="/z3" element={<Z3 />} />{/* Z3 page */}
        <Route path="/z4" element={<Z4 />} />{/* Z4 page */}
        <Route path="/z5" element={<Z5 />} />{/* Z5 page */}
        <Route path="/z6" element={<Z6 />} />{/* Z6 page */}
        <Route path="/z7" element={<Z7 />} />{/* Z7 page */}
        <Route path="/z8" element={<Z8 />} />{/* Z8 page */}
        <Route path="/z9" element={<Z9 />} />{/* Z9 page */}
        <Route path="/z10" element={<Z10 />} />{/* Z10 page */}
        <Route path="/z11" element={<Z11 />} />{/* Z11 page */}
        <Route path="/z12" element={<Z12 />} />{/* Z12 page */}
      </Routes>
    </Router>
  );
}

export default App;
